import React from "react";

export default function KmCell({ row, cell, table }) {
	const hiddenColumns = table.options.meta?.hiddenColumns;
	const columnId = cell.column.id;

	const ignoredColumn = hiddenColumns?.find((item) => item.id === columnId);

	if (!ignoredColumn?.value) {
		return <div className="ignore"></div>;
	}

	let { km, kmMax } = row.original;
	if (kmMax == null) {
		kmMax = 100000;
	}

	const displayValue = Number(km) === 0 ? "--" : km;

	return (
		<div>
			{Number(km) > Number(kmMax) ? <strong className="text-danger">{displayValue}</strong> : <>{displayValue}</>}
		</div>
	);
}